const statusLabels = {
  draft: "Rascunho",
  sending: "Enviando",
  sent: "Enviada",
  closed: "Encerrada",
};

const statusClass = {
  draft: "bg-secondary",
  sending: "bg-warning text-dark",
  sent: "bg-success",
  closed: "bg-dark",
};

export default {
  name: "SurveyList",
  data() {
    return {
      loading: false,
      items: [],
      currentPage: 1,
      lastPage: 1,
      total: 0,
      statusFilter: "",
    };
  },
  mounted() {
    this.fetchSurveys();
  },
  methods: {
    async fetchSurveys() {
      this.loading = true;
      try {
        const params = { page: this.currentPage, per_page: 20 };
        if (this.statusFilter) params.status = this.statusFilter;
        const res = await this.$surveyAdminService.list(params);
        const page = res.data || {};
        this.items = page.items || [];
        this.currentPage = page.meta?.page || 1;
        this.lastPage = page.meta?.last_page || 1;
        this.total = page.meta?.total || 0;
      } catch (e) {
        this.$eventBus.$emit("showToast", {
          title: "Erro",
          msg: e.message || "Erro ao carregar pesquisas.",
        });
      } finally {
        this.loading = false;
      }
    },
    applyFilter() {
      this.currentPage = 1;
      this.fetchSurveys();
    },
    changePage(page) {
      if (page < 1 || page > this.lastPage) return;
      this.currentPage = page;
      this.fetchSurveys();
    },
    statusLabel(status) {
      return statusLabels[status] || status;
    },
    statusClass(status) {
      return statusClass[status] || "bg-secondary";
    },
    formatDate(date) {
      return date ? this.$moment(date).format("DD/MM/YYYY HH:mm") : "-";
    },
  },
};
